import { motion } from 'framer-motion';
import {
  Accordion,
  AccordionContent,
  AccordionItem,
  AccordionTrigger,
} from './ui/accordion';
import { faq, siteConfig } from '../lib/siteConfig';
import { MessageCircle } from 'lucide-react';

export const FAQ = () => {
  return (
    <section
      id="faq"
      className="py-20 lg:py-28 bg-[#0F0F0F]"
      data-testid="faq-section"
    >
      <div className="max-w-4xl mx-auto px-4 sm:px-6 lg:px-12">
        {/* Header */}
        <motion.div
          initial={{ opacity: 0, y: 30 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true }}
          transition={{ duration: 0.6 }}
          className="text-center mb-12"
        >
          <span className="inline-block text-[#FF6B00] font-semibold uppercase tracking-wider text-sm mb-4">
            Dúvidas Frequentes
          </span>
          <h2 className="text-3xl sm:text-4xl lg:text-5xl font-bold text-white mb-6">
            Perguntas <span className="text-[#FF6B00]">Frequentes</span>
          </h2>
          <p className="text-lg text-[#999] max-w-2xl mx-auto">
            Tire suas principais dúvidas sobre nossos serviços. 
            Caso não encontre o que procura, entre em contato conosco.
          </p>
        </motion.div>
        
        {/* FAQ Accordion */}
        <motion.div
          initial={{ opacity: 0, y: 30 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true }}
          transition={{ duration: 0.6, delay: 0.2 }}
        >
          <Accordion type="single" collapsible className="space-y-4">
            {faq.map((item, index) => (
              <AccordionItem
                key={index}
                value={`item-${index}`}
                className="bg-[#1A1A1A] border border-[#333] px-6 data-[state=open]:border-[#FF6B00] transition-colors duration-300"
                data-testid={`faq-item-${index + 1}`}
              >
                <AccordionTrigger className="py-5 text-left hover:no-underline">
                  <span className="text-white font-semibold text-lg pr-4">
                    {item.pergunta}
                  </span>
                </AccordionTrigger>
                <AccordionContent className="pb-5 text-[#999] leading-relaxed">
                  {item.resposta}
                </AccordionContent>
              </AccordionItem>
            ))}
          </Accordion>
        </motion.div>
        
        {/* CTA */}
        <motion.div
          initial={{ opacity: 0, y: 20 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true }}
          transition={{ duration: 0.5, delay: 0.4 }}
          className="text-center mt-12"
        >
          <p className="text-[#999] mb-4">
            Ainda tem dúvidas? Fale diretamente conosco!
          </p>
          <a
            href={siteConfig.linkWhatsApp}
            target="_blank"
            rel="noopener noreferrer"
            className="inline-flex items-center gap-2 bg-[#25D366] hover:bg-[#20BA5C] text-white px-6 py-3 font-bold text-sm uppercase tracking-wide transition-colors duration-300"
            data-testid="faq-cta-whatsapp"
          >
            <MessageCircle className="w-5 h-5" />
            Falar no WhatsApp
          </a>
        </motion.div>
      </div>
    </section>
  );
};
